import { Autocomplete, Box, Card, CardHeader, Chip, IconButton, TextField, Tooltip } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { DetalleSistemaUnidadSectorGrupoDTO, DetalleSistemaUnidadSectorGrupoFields as F } from './types'
import { HttpReportes } from './api'
import CachedIcon from '@mui/icons-material/Cached'
import { FilterAltOff, Search } from '@mui/icons-material'
import { WrapperTable } from '../components'
import { CountryAvatar } from '../../../../../components/icons/CountryAvatar'
import { usePaisLogo } from 'src/hooks/usePaisLogo'
import { EntityWithIdAndDescriptionFields } from 'src/types'
import { useEffect, useState } from 'react'

function ReporteDetalleSistemaGrupo() {
    const { paisLogos } = usePaisLogo()
    const [data, setData] = useState<DetalleSistemaUnidadSectorGrupoDTO[]>([])
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState('')
    const [selectedPais, setSelectedPais] = useState<{ id: number; descripcion: string } | null>(null)

    const fetchData = () => {
        setLoading(true)
        HttpReportes.getDetalleSistemaUnidadSectorGrupo()
            .then(rows => setData(rows.map((r, i) => ({ ...r, _rowId: i }))))
            .finally(() => setLoading(false))
    }

    useEffect(() => { fetchData() }, [])

    const filtered = data.filter(row => {
        if (filter) {
            const lower = filter.toLowerCase()
            const match = row[F.NombreSistema]?.toLowerCase().includes(lower) ||
                row[F.NombreUnidadNegocio]?.toLowerCase().includes(lower) ||
                row[F.NombreSectorComercial]?.toLowerCase().includes(lower) ||
                row[F.NombreGrupo]?.toLowerCase().includes(lower) ||
                row[F.NombrePais]?.toLowerCase().includes(lower)
            if (!match) return false
        }
        if (selectedPais && row[F.CodPais] !== selectedPais.id) return false
        
return true
    })

    const columnas: GridColDef[] = [
        { headerName: 'País', field: F.NombrePais, flex: 1,
            renderCell: ({ row }) => row[F.NombrePais] ? (
                <Chip label={row[F.NombrePais]} size='small' variant='outlined'
                    avatar={<CountryAvatar countryCode={row[F.CodPais]!} />} />
            ) : null
        },
        { headerName: 'Sistema', field: F.NombreSistema, flex: 2 },
        { headerName: 'Unidad de Negocio', field: F.NombreUnidadNegocio, flex: 2 },
        { headerName: 'Sector Comercial', field: F.NombreSectorComercial, flex: 2 },
        { headerName: 'Grupo', field: F.NombreGrupo, flex: 2 }
    ]

    return (
        <WrapperTable>
            <Card>
                <CardHeader
                    title='Detalle Sistema - Unidad - Sector - Grupo'
                    action={<IconButton disabled={loading} onClick={fetchData}><CachedIcon /></IconButton>}
                />

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', mx: 2, mb: 2, p: 2, borderRadius: 1, bgcolor: 'action.hover' }}>
                    <TextField
                        value={filter} onChange={e => setFilter(e.target.value)}
                        label='Buscar' size='small' sx={{ minWidth: 200, flex: 1 }}
                        InputProps={{ startAdornment: <Search fontSize='small' sx={{ mr: 0.5, color: 'text.secondary' }} /> }}
                    />
                    <Box sx={{ minWidth: 180 }}>
                        <Autocomplete
                            options={paisLogos.map(s => ({ id: s.id, descripcion: s[EntityWithIdAndDescriptionFields.Description] }))}
                            value={selectedPais}
                            onChange={(_, v) => setSelectedPais(v)}
                            getOptionLabel={(o: any) => o.descripcion ?? ''}
                            isOptionEqualToValue={(o: any, v: any) => o.id === v?.id}
                            size='small'
                            renderInput={params => <TextField {...params} label='País' />}
                        />
                    </Box>
                    <Tooltip title='Limpiar filtros'>
                        <IconButton size='small' onClick={() => { setFilter(''); setSelectedPais(null) }}>
                            <FilterAltOff fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </Box>

                <DataGrid
                    disableColumnFilter disableColumnMenu
                    columns={columnas}
                    rows={filtered}
                    loading={loading}
                    getRowId={(row: any) => row._rowId}
                    density='compact'
                    autoHeight
                />
            </Card>
        </WrapperTable>
    )
}

export default ReporteDetalleSistemaGrupo
